module.exports = __webpack_public_path__ + "assets/images/Alimentos.bea3fae3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kit-plans/icons/Alimentos.png
// module id = 793
// module chunks = 1